import { useSprintMutation, useSprintQueryClient, SprintMutationResult } from "sprint-common-web";

import { UpdateFileRecordContentRequest } from "../../../../../../common/api/master-api/file-records/update/content/UpdateFileRecordContentRequest";
import { useFileRecordApi } from "../../../../../../common/api/master-api/file-records/useFileRecordApi";
import { FileRecordQueryKey } from "../../../../../common/file-record-details/FileRecordQueryKey";

export interface UseEditFileRecordContent {
    updateFileRecordContent: SprintMutationResult<UpdateFileRecordContentRequest, void>;
}

export const useEditFileRecordContent = ({
    invalidationKey
}: {
    invalidationKey?: string;
}): UseEditFileRecordContent => {
    const fileRecordApi = useFileRecordApi();
    const sprintQueryClient = useSprintQueryClient();

    const updateFileRecordContent = useSprintMutation<UpdateFileRecordContentRequest, void>({
        mutationFn: async ({ id, content }: UpdateFileRecordContentRequest) => {
            if (!id) {
                throw new Error("File record ID is required to update file record content.");
            }

            return fileRecordApi.updateFileRecordContent({ id, content });
        },
        onSettled: async () => {
            await sprintQueryClient.invalidateQueries({
                queryKey: [FileRecordQueryKey.FileRecordDetails, invalidationKey]
            });
        }
    });

    return {
        updateFileRecordContent
    };
};
